import { Avatar, Box } from "@mui/material";
import { Link } from "@reach/router";
import React from "react";
import notificationUtil from "../../utils/notificationUtil";
import ilocalboxAvatarlogo from "../home/images/ilocalboxlogo.png";

export const TaskNotificationComponent = ({ props }) => {
  return (
    <Box component="section" {...props}>
      <Link
        to="/home/taskmanager"
        style={{
          textDecoration: "none",
          color: "black",
        }}
      >
        <Box
          component="div"
          sx={[
            {
              backgroundColor: "transparent",
              transition: "background-color 2s ease 0s",
              marginLeft: "-8px",
              marginRight: "-8px",
              marginBottom: "4px",
              borderRadius: "3px",
              p: "5px 0",
              ":hover": {
                background: "#ECEDF0",
              },
            },
          ]}
        >
          <Box sx={{ display: "flex", width: "100%" }}>
            <Box sx={{ mr: "10px", ml: "10px", mt: "2px" }}>
              <Avatar
                alt="UserAvatar"
                src={
                  props["PhotoURL"] ? props["PhotoURL"] : ilocalboxAvatarlogo
                }
              />
              {/* <img
                src={props["PhotoURL"]}
                alt="UserProfile"
                height="40"
                width="40"
                style={{ borderRadius: "50%" }} */}
              {/* /> */}
            </Box>
            <Box sx={{ width: "100%" }}>
              <Box
                component="p"
                sx={{
                  fontSize: "13px",
                  fontWeight: "500",
                  lineHeight: "15px",
                  m: 0,
                }}
              >
                {props["Type"] === "CREATE" &&
                  `${props["UserName"] + " assinged task to you."}`}
                {props["Type"] === "UPDATE" &&
                  `${props["UserName"] + " updated task."}`}
                {props["Type"] === "DELETE" &&
                  `${props["UserName"] + " deleted task."}`}
                <Box
                  component="span"
                  sx={{
                    fontSize: "10px",
                    fontWeight: "400",
                    whiteSpace: "nowrap",
                    marginLeft: "5px",
                    color: "#6B778C",
                  }}
                >
                  {notificationUtil.timeSince(new Date(props["CreatedOn"]))}
                </Box>
              </Box>
              <Box
                component="p"
                sx={{
                  fontSize: "12px",
                  lineHeight: "14px",
                  m: 0,
                }}
              >
                {props["TaskName"]}
                <Box
                  component="span"
                  sx={{
                    fontSize: "10px",
                    fontWeight: "500",
                    whiteSpace: "nowrap",
                    color: "#6B778C",
                  }}
                >
                  {" • "}
                  {props["Priority"]}
                </Box>
              </Box>
              <Box
                component="p"
                sx={{
                  fontSize: "11px",
                  lineHeight: "14px",
                  m: 0,
                }}
              >
                {props["TaskTypeName"].toUpperCase()}
                <Box
                  component="span"
                  sx={{
                    fontSize: "10px",
                    fontWeight: "500",
                    whiteSpace: "nowrap",
                    color: "#6B778C",
                  }}
                >
                  {" • "}
                  {props["Status"]}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Link>
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/TaskNotificationComponent.js